import { CircleCheck } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const checklistItems = ["Real-time FAO & ISRIC global data integration", "Accurate horizon classification (O, A, B, C)", "Chemical composition & pH level analysis", "Rare profile discovery & collection system"];
export default function AboutMe() {
  return <section data-section-id="227788" id="scientific-methodology" className="bg-background text-foreground py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-3">
              <span className="text-secondary text-sm font-default font-medium tracking-widest uppercase">
                Scientific Methodology
              </span>
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-primary leading-tight">
                Precision Excavation. Global Data.
              </h2>
            </div>

            <p className="text-foreground font-default text-lg leading-relaxed opacity-90">
              Terrigma utilizes advanced earth science datasets to simulate authentic soil profiles from all 195 countries. Every excavation reveals a unique stratigraphic sequence, allowing players to identify and archive the planet's diverse lithosphere with laboratory-grade accuracy.
            </p>

            <ul className="flex flex-col gap-4">
              {checklistItems.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="w-6 h-6 text-accent shrink-0 mt-0.5" />
                  <span className="text-foreground font-default text-base">{item}</span>
                </li>)}
            </ul>

            <div className="bg-card/50 backdrop-blur-md border border-border text-foreground p-6 md:p-8 rounded-md mt-2 shadow-lg">
              <p className="text-lg font-mono font-medium leading-relaxed text-accent">
                "The integration of ISRIC data ensures that every profile collected is a true representation of the earth's crust at those specific coordinates."
              </p>
            </div>
          </div>

          {}
          <div className="relative w-full max-w-md mx-auto lg:max-w-none">
            <AspectRatio ratio={4 / 5} className="bg-muted rounded-md overflow-hidden shadow-2xl border border-primary/20">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649185/img/soil_stratigraphy_diagram.png" alt="Vertical soil profile diagram showing horizons" className="object-cover w-full h-full" />
              {}
              <div className="absolute bottom-4 left-4 right-4 grid grid-cols-3 gap-2">
                <div className="bg-black/60 backdrop-blur-sm p-2 rounded-sm border border-white/10">
                  <p className="text-[10px] text-accent font-mono uppercase">pH Level</p>
                  <p className="text-sm font-mono text-primary">6.4</p>
                </div>
                <div className="bg-black/60 backdrop-blur-sm p-2 rounded-sm border border-white/10">
                  <p className="text-[10px] text-accent font-mono uppercase">Carbon</p>
                  <p className="text-sm font-mono text-primary">2.4%</p>
                </div>
                <div className="bg-black/60 backdrop-blur-sm p-2 rounded-sm border border-white/10">
                  <p className="text-[10px] text-accent font-mono uppercase">Rarity</p>
                  <p className="text-sm font-mono text-primary">Legendary</p>
                </div>
              </div>
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>;
}